module.exports = __webpack_public_path__ + "static/img/womanminibags.42bd275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/womanminibags.jpg
// module id = cYrS
// module chunks = 1